import { TokenTransferRequestFieldNames } from "./constants";

export type TokenTransferRequestUrl = {
  [TokenTransferRequestFieldNames.contractAddress]: string;
  [TokenTransferRequestFieldNames.tokenId]: string;
};

export type TokenTransferRequestBody = {
  [TokenTransferRequestFieldNames.walletAddress]: string;
  [TokenTransferRequestFieldNames.legalAgreement]: boolean;
};

export type TokenTransferResponseBody = {
  transactionId?: string;
  error?: string;
};

export enum TOKEN_TRANSFER_ERROR_CODE {
  BadRequest = 400,
  ExistingTransferPending = 409,
}

export enum TokenTransferStatus {
  Pending = "Pending",
  Failed = "Failed",
  Completed = "Completed",
}

export type TokenTransferStatusResponseBody = {
  status: TokenTransferStatus | undefined;
  transactionId?: string;
  error?: string;
};
